<template>
    <div>
      <Pos_invoices_tax_refund_pdf/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_refund_pdf from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_refund_pdf";
  export default {
    name: "PosInvoicesTaxRefundPdf",
    components: {
      Pos_invoices_tax_refund_pdf,
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  